<template>
    <div>
        <Header :type="2" :sub-type="5"></Header>
        <div class="banner"></div>
        <ProductFeatures></ProductFeatures>
        <MoreFunction></MoreFunction>
    </div>
</template>
<script>
import Header from '../../components/header.vue'
import ProductFeatures from './productFeatures.vue'
import MoreFunction from './moreFunction.vue'
export default {
  name: "QXB",
  components: {
    Header,
    ProductFeatures,
    MoreFunction
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
@import "../../assets/style/utils.less";
.banner {
    height: 25vw;
    width: 100%;
    background-image: url('../../../static/images2/QXB_banner.webp');
    background-color: #ebf2fe;
    background-repeat: no-repeat;
    background-size: cover;
}
@media screen and (max-width: 900px) {
  .banner {
    height: .h5px2vw(703)[@result];
    background-image: url('../../../static/images2/h5/QXB_banner.webp');
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/QXB/index.vue